export default function AttachRecommendationDocumentDirective() {
  return {
    template: require('./attach-recommendation-document.html'),
    scope: {
      customerId: '=',
      recommendationId: '=',
      serviceId: '=',
      parentDocumentId: '=',
      documentId: '=',
      document: '=',
    },
    controller: 'AttachRecommendationDocumentController',
    controllerAs: 'attachRecommendationDocumentVM',
    bindToController: true,
    replace: true
  };
}
